import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface BreadcrumbContextValue {
  extra: string | null;
  setExtra: (v: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);

// Lets a page (e.g. the in-page Lead Wizard swap, which has no route change)
// push an extra trailing breadcrumb segment - SalesTopBar reads it back.
export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [extra, setExtra] = useState<string | null>(null);
  const value = useMemo(() => ({ extra, setExtra }), [extra]);
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
};

export function useBreadcrumb(): BreadcrumbContextValue {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
  return ctx;
}
